"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var SvgMeal = function SvgMeal(props) {
  return /*#__PURE__*/React.createElement("svg", (0, _extends2["default"])({
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3.25 6.955v3.553m2.847-9.08H.93v2.62c0 1.615.654 2.907 2.583 2.907 1.93 0 2.584-1.292 2.584-2.907v-2.62zM3.514 6.955v3.553m-1.94 0H5.45M9.465.935v10.142M7.861.924v3c0 .43.321 1.291 1.604 1.291 1.282 0 1.603-.861 1.603-1.292v-3",
    stroke: "#17181A"
  }));
};

var Memo = /*#__PURE__*/(0, React.memo)(SvgMeal);
var _default = Memo;
exports["default"] = _default;